import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/nj-skyline.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Web Design and Development in New Jersey?
            </h2>
            <p>
              We have a track record of delivering exceptional results. Our
              portfolio showcases a history of successful projects that speak to
              our commitment to excellence. As a New Jersey-based company, we
              possess proficient knowledge of the local market and its relative
              trends. Our approach is never one-size-fits-all. We craft
              tailor-made solutions to match your specific business goals and
              requirements. Moreover, we provide cost-effective solutions
              without compromising on quality, ensuring your project remains
              within budget. Our dedicated support team is ready to assist you
              with post-launch, ensuring your website continues to perform at
              its best. As a leading web design and development company in New
              Jersey, we embrace innovation, constantly seeking new and creative
              ways to enhance your website's functionality, design, and user
              experience.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
